/**
 * /assistant — the assistant about the whole base (#765 Ф3, spec
 * 2026-09-30-assistant-org-ui-release §1.2).
 *
 * Until the `org` contour is released the route redirects: the release is one
 * line in `ASSISTANT_RELEASED_SCOPES`, a constant, so `beforeLoad` can read it
 * without waiting for the role (the reason other guards moved in-tree). Open
 * to every role: what a viewer may ask about is the server's boundary, not
 * the screen's. The flag and the tier are `FeatureGate` and the panel's own
 * refusal.
 */
import { useEffect } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAssistantScopeReleased } from '@aica/api-types/schemas';
import { FeatureGate } from '@/components/ui/FeatureGate';
import { useAssistantDrawerSafe } from '@/contexts/AssistantDrawerContext';
import { AssistantWorkspace } from '@/components/assistant/AssistantWorkspace';

export const Route = createFileRoute('/assistant')({
  beforeLoad: () => {
    if (!isAssistantScopeReleased('org')) throw redirect({ to: '/dashboard' });
  },
  component: function AssistantRouteGated() {
    // The page answers about the whole base now: a drawer left open over it —
    // from the menu, Cmd+K, the header button or the drawer's own «whole base»
    // — closes on arrival, in this one place (#1357).
    const closeDrawer = useAssistantDrawerSafe()?.closeAssistant;
    useEffect(() => {
      closeDrawer?.();
    }, [closeDrawer]);
    return (
      <FeatureGate flag="enableAIAssistant">
        <AssistantWorkspace />
      </FeatureGate>
    );
  },
});
